import script from "./mainBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./mainBox.vue?vue&type=script&setup=true&lang=ts"

import "./mainBox.vue?vue&type=style&index=0&id=254e5ac7&lang=scss&scoped=true"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-254e5ac7"]])

export default __exports__